<template>
  <div class="column is-12 is-paddingless">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('detailCatalogue.produitAchatLie.title') }}
        </p>
      </header>
      <div class="card-content height-90">
        <div class="columns">
          <div class="column is-6">
            <b-field :label="$t('detailCatalogue.produitAchatLie.produit.titleDetail')"
                     custom-class="has-text-default is-italic has-text-weight-light">
              <span class="has-text-weight-bold" v-if="produitOppose">
                <router-link-blank :to="{ name: isDivers ?
                'c.bodac.catalogue-divers' : 'c.bodac.catalogue-location',
                params: getParams}"
                                   :message="libelle">
              </router-link-blank>
              </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SENS_ACHAT } from '@/configuration/devisConf';

export default {
  name: 'detailProduitOpposeLie',
  props: {
    produitOppose: {
      required: true,
      default: null,
    },
    isDivers: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      libelle: '',
    };
  },
  computed: {
    isAchat() {
      return this.produitOppose.sens === SENS_ACHAT;
    },
    getParams() {
      const params = {};
      params.id = this.produitOppose.id;
      if (this.isAchat) params.isFromCatalogueAchat = true;
      return params;
    },
  },
  mounted() {
    if (this.produitOppose) {
      this.libelle = this.produitOppose.libelle + ' - ' + this.produitOppose.reference;
    }
  },
};
</script>

<style scoped>

</style>
